let STATUS_CONFIG = {
  "-2": {
    text: "Отменена клиентом",
    color: "gray",
    disabled: true,
    bordered: true
  },
  "-1": {
    text: "Отменена нотариусом",
    color: "gray",
    disabled: true,
    bordered: true
  },
  "0": {
    text: "Черновик",  // "Ожидает подтверждения",
    color: "gray",
    disabled: false,
    bordered: false
  },

  // new FCIIT statuses
  "Finished": {  // 1
    text: "Передан результат",
    color: "green",
    disabled: false,
    bordered: false
  },
  "Canceled": {  // 2
    text: "Отмена приема",
    color: "red",
    disabled: false,
    bordered: false
  },
  "PreBooked": {  // 3
    text: "Предварительное бронирование",
    color: "orange",
    disabled: false,
    bordered: false
  },
  "OrderAccepted": {  // 4
    text: "Заявление получено",
    color: "green",
    disabled: false,
    bordered: false
  },
  "5": {  // ??? no such status anymore?
    text: "Приглашение на прием",
    color: "green",
    disabled: false,
    bordered: false
  },
  "NotaryAskDoc": {  // 5
    text: "Запрос доп. документов",
    color: "orange",
    disabled: false,
    bordered: false
  },
  "DocReceived": {  // 6
    text: "Документы получены",
    color: "green",
    disabled: false,
    bordered: false
  },
  "PreBookingTimeout": {  // 7
    text: "Отмена предварительного бронирования по таймауту",
    color: "red",
    disabled: false,
    bordered: false
  },
};

export default STATUS_CONFIG;
